import React from 'react';
import { Link } from 'react-router-dom';
import { Globe } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

// Shared public header: one 64px row at every width (no wrapping at 390).
// Used on home-adjacent pages, auth pages, terms, privacy, /sso and the 404.
export default function SiteNav() {
  const { user } = useAuth();
  const accountTo = user?.role === 'admin' ? '/admin' : '/portal';
  return (
    <nav className="fixed top-0 w-full z-50 border-b border-white/5 bg-slate-950/80 backdrop-blur-md" data-testid="landing-nav">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-2">
        <Link to="/" className="flex items-center gap-2 shrink-0 min-h-[44px]">
          <div className="w-8 h-8 bg-indigo-500 rounded-lg flex items-center justify-center">
            <Globe className="w-5 h-5 text-white" />
          </div>
          <span className="text-xl font-bold text-white whitespace-nowrap" style={{ fontFamily: 'Outfit' }}>EasyPeazy</span>
        </Link>
        <div className="flex items-center gap-1 sm:gap-3 shrink-0">
          <Link to="/pricing" className="hidden sm:inline-flex items-center min-h-[44px] whitespace-nowrap text-slate-300 hover:text-white transition-colors px-3 font-medium" data-testid="nav-pricing-btn">Pricing</Link>
          {user ? (
            <Link to={accountTo} className="inline-flex items-center min-h-[44px] whitespace-nowrap text-slate-300 hover:text-white transition-colors px-3 font-medium" data-testid="nav-account-btn">Account</Link>
          ) : (
            <>
              <Link to="/login" className="inline-flex items-center min-h-[44px] whitespace-nowrap text-slate-300 hover:text-white transition-colors px-3 font-medium" data-testid="nav-login-btn">Sign in</Link>
              <Link to="/signup" className="inline-flex items-center min-h-[44px] whitespace-nowrap bg-indigo-500 hover:bg-indigo-600 text-white px-4 sm:px-5 rounded-lg font-semibold transition-all active:scale-95 shadow-lg shadow-indigo-500/20" data-testid="nav-signup-btn">
                <span className="sm:hidden">Start</span><span className="hidden sm:inline">Get started</span>
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
